import { QUESTION_TYPES } from '@/utils/constants'

export const acceptedTypes = [
  QUESTION_TYPES.radio,
  QUESTION_TYPES.checkbox,
  QUESTION_TYPES.matrixRadio,
  QUESTION_TYPES.matrixCheckbox,
  QUESTION_TYPES.dragAndDrop,
]

export const singleReferenceTypes = [QUESTION_TYPES.radio, QUESTION_TYPES.checkbox]
